import useGetRequest from '../../../common/services/useGetRequest';

// This method will fetch data on the first call. after, it will check based on the existence of licenseData
// If first call was successful, we will skip the api call
export default function useGetLicenseInformation(instanceId, licenseData) {
    const isEnabled = licenseData == null;
    const [data, isLoading, error] = useGetRequest(
        `/api/v1/instances/${instanceId.slice(6)}/licensing_info`,
        { enabled: isEnabled },
    );

    // if not enabled, means we have already obtained the data once before and no longer need to load
    return [data, isEnabled ? isLoading : false, error];
}
